import _isEmpty from 'lodash/isEmpty';

export function filterFilesBySourceTag(files, sourceFilter) {
  if (_isEmpty(files)) return [];

  if (sourceFilter === 'All') return files;

  return files.filter(({ source }) => source === sourceFilter);
}
